module.exports = __webpack_public_path__ + "static/media/canaldemiromain.ef204b85.woff";